import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { from, Subscription } from 'rxjs';

@Component({
  selector: 'tvt-logistics-india-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  paramsSubscription: Subscription;
  username: string;
  loading: boolean = false;
  forgotPasswordSubscription: Subscription;
  constructor(
    public activatedRoute: ActivatedRoute,
    public router: Router,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.paramsSubscription = this.activatedRoute.queryParams.subscribe(
      (data) => {
        if (data) {
          this.username = data.username;
        }
      }
    );
  }

  onSubmit(code, password) {
    if (this.username && code.value && password.value) {
      this.loading = true;
      this.forgotPasswordSubscription = from(
        Auth.forgotPasswordSubmit(this.username, code.value, password.value)
      ).subscribe(
        (data) => {
          this.loading = false;
          this.router.navigate(['/sign-in']);
          this._snackBar.open('Password Reset Successfully', null, {
            duration: 5000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: 'custom-snackbar-success',
          });
        },
        (error) => {
          this.loading = false;
          this._snackBar.open(error.message, null, {
            duration: 5000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: 'custom-snackbar-error',
          });
        }
      );
    }
  }

  ngOnDestroy() {
    this.paramsSubscription?.unsubscribe();
    this.forgotPasswordSubscription?.unsubscribe();
  }
}
